import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

import { LoanRequest } from '../types/General';
import { VEHICLE_TYPE } from '../utils/enums';

interface FinancialDetailModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  details: LoanRequest;
}

export default function FinancialDetailModal({
  open,
  onClose,
  setOpen,
  details,
}: FinancialDetailModalProps) {
  // const image = Array.isArray(details?.image)
  //   ? details.image[0]
  //   : details?.image || "/static/images/vehicle_side.jpg";
  return (
    <Modal
      className="modal fcDetail_modal"
      id="fcDetailModal"
      aria-labelledby="fcDetail-modal-title"
      aria-describedby="fcDetail-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Financial Details</h2>
          </div>
          <div className="fcustomer_info gap_m">
            <div className="left_s">
              <figure className="blog_dtl_img">
                <img
                  src={
                    details?.vehicle?.image
                      ? details?.vehicle?.image
                      : '/static/images/vehicle_side.jpg'
                  }
                  alt=""
                  aria-hidden="true"
                />
              </figure>
            </div>
            <div className="right_s">
              <div className="fcComment_box" style={{ marginTop: '10px' }}>
                <h2>User Details</h2>
                <ul className="inspection_dtl_list">
                  <li>
                    <figure>
                      <img
                        src={details?.requestedBy?.image || '/static/images/user_attachment.jpg'}
                        alt=""
                      />
                    </figure>
                    <p>
                      <b>{details?.requestedBy?.name || '-'}</b>
                      <b>{details?.requestedBy?.email || '-'}</b>
                      {/* <b>{details?.requestedBy?.storeName || "-"}</b> */}
                    </p>
                  </li>
                </ul>
              </div>
              {/* <h2>Emi Details</h2> */}
              <div className="details_md">
                <h3>Loan Amount</h3>
                <p>{details?.loanAmount || '-'}</p>
                <h3>Down Payment</h3>
                <p>{details?.downPayment || '-'}</p>
                <h3>EMI Amount</h3>
                <p>{details?.emiAmount || '-'}</p>
                <h3>Existing Emi</h3>
                <p>{details?.existingEmi || '-'}</p>
                <h3>Income</h3>
                <p>{details?.income || '-'}</p>
                <h3>Interest Rate</h3>
                <p>{details?.interestRate || '-'}</p>
              </div>

              <div className="details_md">
                {details?.vehicle?.vehicleType && (
                  <div>
                    {' '}
                    <h3>Vehicle Id</h3>
                    <p>
                      {details?.vehicle?.vehicleType === VEHICLE_TYPE.CAR
                        ? 'Car'
                        : details?.vehicle?.vehicleType === VEHICLE_TYPE.BIKE
                          ? 'Bike'
                          : details?.vehicle?.vehicleType === VEHICLE_TYPE.TRUCK
                            ? 'Truck'
                            : details?.vehicle?.vehicleType === VEHICLE_TYPE.HEAVY_VEHICLE
                              ? 'Heavy Vehicle'
                              : '- -'}
                    </p>
                  </div>
                )}

                {details?.vehicle?.name && (
                  <div>
                    {' '}
                    <h3>Vehicle Name</h3>
                    <p>{details?.vehicle?.name}</p>
                  </div>
                )}
                {details?.requestedBy?.storeName && (
                  <div>
                    {' '}
                    <h3>Store Address</h3>
                    <p>{details?.requestedBy?.storeName || '-'}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
